<template>
  <div>
    <nnav></nnav>

    <div class="bgimg">
      <div class="userlist">
        <div class="list_head">
          <div class="topTitle" style="margin-left: 40px;padding: 8px 0  ;">
            <img
              style="margin-right: 8px;"
              src="../../../assets/images/dh111.png"
              alt=""
            />
            <span style="font-size: 14px;color: #2C2F37;">云服务</span
            ><span style="color: #868E99;font-size: 14px;"
              >&nbsp;>&nbsp;分组管理</span
            >
          </div>

          <div class="contnet manager" :style="{ minHeight: MHeight }">
            <div class="search searchBox" style="margin-bottom: 20px;">
              <el-button icon="el-icon-plus" type="primary" @click="addBtn()"
                >添加</el-button
              >

              <el-button
                style="background:#5B85FF;color:#fff"
                class="iconfont icon-daorushuju"
                type="primary"
                @click="addExport()"
                ><i v-html="' '"></i> 导入初始化数据</el-button
              >
            </div>

            <el-tabs v-model="activeName" @tab-click="seeBtn">
              <el-tab-pane
                v-for="(item, index) in listRes"
                :key="item.id"
                :label="item.name"
                :name="item.name"
              >
                <div class="list_box">
                  <div class="listItem">
                    <div
                      class="topTitleBox"
                      :style="{ background: item.backgroundColor }"
                    ></div>
                    <div class="listBody">
                      <div class="jy">
                        <div class="jyMsg">
                          <div style="display: flex;">
                            <p
                              style="font-size: 20px;font-weight: 500;color: #0A101E;"
                            >
                              {{ item.name }}
                            </p>
                            <li class="liBox">
                              <i
                                class="iconfont icon-xiugai"
                                @click="addBtn(item, '1')"
                                style="cursor: pointer;margin-top: 1px;font-size: 18px;margin-right: 3px;"
                              ></i>
                              <span
                                @click="addBtn(item, '1')"
                                class="decoration1"
                                style="cursor: pointer;line-height: 22px;"
                                >编辑</span
                              >

                              <span
                                style="margin-left:10px;"
                                @click="delBtn(item)"
                                class="iconfont icon-shanchu"
                              ></span>
                              <span @click="delBtn(item)" class="decoration1"
                                >删除</span
                              >
                            </li>
                          </div>

                          <li
                            class="liBox"
                            style="font-size: 16px;align-items: center;display: flex;"
                          ></li>

                          <ul class="userMsgBox">
                            <li v-for="(e, i) in item.memsList" :key="e.id">
                              <img
                                v-if="e.selfImage"
                                :src="'/api' + e.selfImage"
                                alt="加载失败"
                              />
                              <img
                                v-if="!e.selfImage"
                                src="../../../assets/images/crm/nan.png"
                                alt
                              />
                              <div>
                                <p>{{ e.memsName }}</p>
                                <span class="iconfont icon-shouji01">{{
                                  e.memsPhone
                                }}</span>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <!-- <h3 style="margin-bottom: 0;" @click="editBtn(item,'4')"><span class="iconfont icon-xiugai" ></span>操作账户</h3>   -->

                      <li
                        class="liBox"
                        style="font-size: 16px;align-items: center;display: flex;color: #5B85FF;"
                      >
                        <i
                          class="iconfont icon-xiugai"
                          @click="editBtn(item, '4')"
                          style="cursor: pointer;font-size: 18px;margin-right: 3px;"
                        ></i>
                        <span
                          @click="editBtn(item, '4')"
                          class="decoration1"
                          style="cursor: pointer;line-height: 22px;"
                          >绑定交易账户</span
                        >
                      </li>

                      <!-- 交易账户 -->
                      <div class="user-list">
                        <li
                          class="user-li"
                          v-for="(e, i) in item.evalJees"
                          :key="i"
                        >
                          <p>账&emsp;&emsp;号：{{ e.userCode }}</p>
                          <p
                            style="white-space:nowrap;text-overflow: ellipsis;overflow: hidden;"
                          >
                            账户名称：{{ e.userName }}
                          </p>
                          <p>
                            账户类型：{{
                              e.userType == "1"
                                ? "投顾账户"
                                : e.userType == "2"
                                ? "模拟账户"
                                : e.userType == "3"
                                ? "产品账户"
                                : e.userType == "4"
                                ? "外部投顾账户"
                                : ""
                            }}
                          </p>
                          <p>交易倍率：{{ e.multiple }}</p>
                        </li>
                      </div>

                      <li
                        class="liBox"
                        style="font-size: 16px;align-items: center;display: flex;color: #5B85FF;"
                      >
                        <!-- <i class="iconfont icon-xiugai" @click="editBtn(item,'4')" style="cursor: pointer;font-size: 18px;margin-right: 3px;"></i>
                    <span @click="editBtn(item,'4')" class="decoration1" style="cursor: pointer;line-height: 22px;">交易账户</span>-->

                        <p style="cursor: pointer;">
                          <i
                            style="font-size: 17px;"
                            @click="downloadBtn"
                            class="iconfont icon-xiazai1"
                          ></i>
                          <span @click="downloadBtn" class="decoration1"
                            >下载持仓汇总数据</span
                          >
                        </p>

                        <p style="cursor: pointer;margin-left: 20px;">
                          <i
                            @click="uploadBtn(item)"
                            style="font-size: 14px;"
                            class="iconfont icon-daorushuju"
                          ></i>
                          <span @click="uploadBtn(item)" class="decoration1"
                            >导入持仓汇总数据</span
                          >
                        </p>
                      </li>

                      <div class="table" style="margin-top: 10px;">
                        <el-table
                          :header-cell-style="{ background: '#F6F9FF' }"
                          :data="allData"
                          border
                          row-key="id"
                          style="width: 100%"
                        >
                          <el-table-column
                            prop="userCode"
                            align="center"
                            label="账号"
                          ></el-table-column>

                          <el-table-column
                            prop="instrumentID"
                            align="center"
                            label="合约"
                          ></el-table-column>
                          <el-table-column align="center" label="买卖">
                            <template slot-scope="scope">
                              <span
                                :style="{
                                  color:
                                    scope.row.posiDirection == 50
                                      ? '#f00'
                                      : '#10c866'
                                }"
                                >{{
                                  scope.row.posiDirection == 50 ? "买" : "卖"
                                }}</span
                              >
                            </template>
                          </el-table-column>

                          <el-table-column
                            prop="position"
                            align="center"
                            label="手数"
                          ></el-table-column>

                          <el-table-column
                            prop="averagePrice"
                            align="right"
                            label="开仓均价"
                          >
                            <template slot-scope="scope">
                              {{ scope.row.averagePrice | rbstateFormat }}
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="openCost"
                            align="right"
                            label="开仓成本"
                          >
                            <template slot-scope="scope">
                              {{ scope.row.openCost | rbstateFormat }}
                            </template>
                          </el-table-column>
                          <el-table-column
                            width="60"
                            align="center"
                            label="操作"
                          >
                            <template slot-scope="scope">
                              <span
                                @click="dataDelBtn(scope.row)"
                                style="color: #3D6BF1;cursor: pointer;"
                                class="iconfont icon-shanchu decoration"
                              ></span>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>

            <!-- 列表 -->
          </div>
        </div>
      </div>
    </div>

    <transition name="el-fade-in-linear">
      <div class="popContainer" v-if="isShow">
        <div
          v-loading="loading"
          element-loading-text="导入中"
          element-loading-spinner="el-icon-loading"
          class="add"
          :style="{ width: dialogWidth, paddingBottom: '20px' }"
        >
          <div class="close"></div>
          <div class="Top" :style="{ width: dialogWidth }">
            {{ title }}
          </div>
          <span
            v-if="!loading"
            @click="clearBtn"
            class="close iconfont icon-close_round_fill_bold
                                    "
          ></span>

          <!-- 添加 编辑 -->
          <div class="formStyle" v-if="showType.add || showType.name">
            <el-form
              style="padding: 30px 60px 0 60px;"
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="110px"
              @submit.native.prevent
              class="demo-ruleForm"
            >
              <el-form-item label="分组名称：" prop="name">
                <el-input
                  style="width:200px"
                  placeholder="请输入分组名称"
                  size="small"
                  v-model="ruleForm.name"
                  @keyup.enter.native="submit"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <div class="form_btn" style="height: auto;margin-top: 50px;">
              <button @click="submit('ruleForm')">确定</button>
            </div>
          </div>

          <div
            class="grouping-divide table "
            style="padding: 0px 30px "
            v-if="showType.edit"
          >
            <div style="display:flex;margin-bottom:10px">
              <h3
                style="width:53%;border-left:2px solid #5b85ff;padding-left:10px;height:16px;line-height:16px"
              >
                未选择账号
              </h3>

              <h3
                style="width:40%;border-left:2px solid #5b85ff;padding-left:10px;height:16px;line-height:16px"
              >
                已选择账号（拖动排序）<span style="color:red;font-size:14px;padding-left:5px">修改账户交易倍率后需要重登多账户交易端。</span>
              </h3>
            </div>

            <div style="display:flex;">
              <el-table
                :data="userLeftList"
                row-key="id"
                :header-cell-style="{ background: '#F6F9FF' }"
                border
                height="400px"
                :row-class-name="style_none"
                style="width: 40%"
                @select="selectRowleft"
                @select-all="selectAllRowleft"
                ref="leftDataList"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <!-- <el-table-column
                  align="center"
                  width="50px"
                  :render-header="renderHeader"
                >
                  <template slot-scope="scope">
                    <el-checkbox
                      @change="checkChange(scope, scope.$index)"
                      :value="scope.row.checked ? true : false"
                    ></el-checkbox>
                  </template>
                </el-table-column> -->

                <el-table-column prop="userCode" align="center" label="账号">
                </el-table-column>

                <el-table-column
                  prop="userName"
                  align="center"
                  label="账号名称"
                >
                </el-table-column>

                <el-table-column align="center" label="交易倍率">
                  <template slot-scope="scope">
                    <div class="inpDiv">
                      <el-input
                        :disabled="true"
                        style="width: 66px;"
                        oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1').replace(/[^\d]/g,'')"
                        size="mini"
                        v-model="scope.row.multiple"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>

                <!-- <el-table-column
                  prop="userName"
                  align="center"
                  width="65"
                  label="优先级"
                >
                  <template slot-scope="scope">
                    <div class="icon_sort" v-if="scope.row.checked">
                      <span
                        :style="{
                          color: scope.$index == 0 ? '#DCDFE6' : '#5b85ff'
                        }"
                        @click="upBtn(scope, scope.$index)"
                        class="iconfont icon-xiangshang4"
                      ></span>
                      <span
                        :style="{
                          color:
                            scope.$index == count - 1 ? '#DCDFE6' : '#5b85ff'
                        }"
                        @click="downBtn(scope, scope.$index)"
                        class="iconfont icon-xiangxia4"
                      ></span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="userCode"
                  width="60"
                  align="center"
                  label="序号"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.checked">{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column> -->
              </el-table>

              <!-- 移动 按钮 -->
              <div style="width:100px" class="middleBtn">
                <div class="leftShiftBtn" @click="rightShiftFun">
                  >>
                </div>
                <div class="rightShiftBtn" @click="leftShiftFun">
                  <<
                </div>
              </div>

              <el-table
                :row-class-name="style_block"
                class="table_t"
                :data="userRightList"
                row-key="id"
                :header-cell-style="{ background: '#F6F9FF' }"
                border
                height="400px"
                style="width: 40%"
                @select="selectRowright"
                @select-all="selectAllRowright"
                ref="rightDataList"
              >
                <el-table-column type="selection" width="55"> </el-table-column>

                <!-- <el-table-column label="拖拽排序" width="80" align="center">
                  <template slot-scope="scope">
                    <i
                      v-if="scope.row.checked ? true : false"
                      class="el-icon-rank allowDrag"
                      style="cursor:pointer"
                    />
                  </template>
                </el-table-column> -->

                <!-- <el-table-column
                  align="center"
                  width="50px"
                  :render-header="renderHeader"
                >
                  <template slot-scope="scope">
                    <el-checkbox
                      @change="checkChange(scope, scope.$index)"
                      :value="scope.row.checked ? true : false"
                    ></el-checkbox>
                  </template>
                </el-table-column> -->

                <el-table-column
                  prop="userCode"
                  width="100"
                  align="center"
                  label="优先级"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>

                <el-table-column prop="userCode" align="center" label="账号">
                </el-table-column>

                <el-table-column
                  prop="userName"
                  align="center"
                  label="账号名称"
                >
                </el-table-column>

                <el-table-column align="center" label="交易倍率">
                  <template slot-scope="scope">
                    <div class="inpDiv">
                      <!-- oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1').replace(/[^\d]/g,'')" -->
                      <!-- oninput="value=value.replace(/^0|[^1-9]/g, '')"  整数 -->
                      <!-- <el-input
                        style="width: 66px;"
                        size="mini"
                        :min="1"
                        v-model.number="scope.row.multiple"
                      ></el-input> -->
                      <el-input-number
                        v-model.number="scope.row.multiple"
                        style="width: 66px;"
                        controls-position="right"
                       
                        :min="0"
                        :max="10000"
                        :controls="false"
                        :precision="2"
                      ></el-input-number>
                    </div>
                  </template>
                </el-table-column>

                <!-- <el-table-column
                  prop="userName"
                  align="center"
                  width="65"
                  label="优先级"
                >
                  <template slot-scope="scope">
                    <div class="icon_sort" v-if="scope.row.checked">
                      <span
                        :style="{
                          color: scope.$index == 0 ? '#DCDFE6' : '#5b85ff'
                        }"
                        @click="upBtn(scope, scope.$index)"
                        class="iconfont icon-xiangshang4"
                      ></span>
                      <span
                        :style="{
                          color:
                            scope.$index == count - 1 ? '#DCDFE6' : '#5b85ff'
                        }"
                        @click="downBtn(scope, scope.$index)"
                        class="iconfont icon-xiangxia4"
                      ></span>
                    </div>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
            <div class="form_btn" style="height: auto;margin-top: 30px;">
              <button @click="editSubmit()">确定</button>
            </div>
          </div>

          <div
            class="form_box"
            style="width: auto;min-height: 190px;"
            v-if="showType.upload"
          >
            <div class="form" style="padding: 0px 30px 0px;min-height: 190px;">
              <div class="col">
                <div
                  style="text-align: right;
                            height: 27px;
                            line-height: 27px;
                            font-size: 16px;
                            padding-right: 15px;
                            margin-top:6px;
                            width:112px"
                >
                  <span style="color:#F56C6C">*&nbsp;</span>附件上传
                </div>
                <div class="right" style="padding-right:55px">
                  <el-upload
                    ref="my-upload"
                    class="avatar-uploader"
                    :action="'/api' + '/ad/upload/upload_file'"
                    :on-remove="removeBtn"
                    name="file"
                    accept=".xlsx"
                    :limit="1"
                    :on-success="handleAvatarSuccess"
                  >
                    <i
                      style="color: #fff;width: 50px;height: 24px;background-color: #62DCB5;text-align: center;border-radius: 2px;display:inline-block;font-size: 14px;line-height: 24px;"
                      >上传</i
                    >
                    <span
                      style="font-size: 14px;color: #475173;margin-top: 7px;margin-bottom: 5px;display:inline-block;"
                    >
                      &emsp;&nbsp;请上传汇总数据，只能上传xlsx格式文件
                    </span>
                  </el-upload>
                  <div
                    style="font-size: 14px;color: #5B85FF;margin-top:5px;margin-left:-2px"
                  >
                    <a
                      download="导入汇总数据"
                      class="decoration2 iconfont icon-xiazai1"
                      target="_blank"
                      href="/api/template.xlsx"
                      style="color:#5b85ff;font-size:14px"
                      >&nbsp;导入汇总数据模板下载</a
                    >
                    <span style="color:#475173"
                      >&nbsp;&nbsp;请确保导入数据的正确性</span
                    >
                  </div>
                </div>
              </div>
              <div class="form_btn" style="height: auto;">
                <button @click="uploadSubmit()">确定</button>
              </div>
            </div>
          </div>

          <div
            class="form_box"
            style="width: auto;min-height: 190px;"
            v-if="downloadShow"
          >
            <div class="form" style="padding: 0px 30px 0px;min-height: 190px;">
              <div class="col">
                <span>是否确认下载持仓汇总数据？</span>
              </div>
              <div class="form_btn" style="height: auto;">
                <button @click="exportData">确定</button>
              </div>
            </div>
          </div>

          <!-- 导入初始化数据 -->
          <div class="exportClass" v-if="showType.export">
            <el-form
              style="padding: 30px 60px 0 60px;"
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="95px"
              class="demo-ruleForm"
            >
              <el-form-item
                style="margin-bottom:0"
                label="附件上传："
                prop="name"
              >
                <el-upload
                  ref="my-upload"
                  class="avatar-uploader"
                  :action="'/api' + '/ad/upload/upload_file'"
                  :on-remove="removeBtn_1"
                  name="file"
                  accept=".xlsx"
                  :limit="1"
                  :on-success="handleAvatarSuccess_1"
                >
                  <i
                    style="color: #fff;width: 70px;height: 24px;background-color: #62DCB5;text-align: center;border-radius: 4px;display:inline-block;font-size: 14px;line-height: 24px;"
                    >上传文件</i
                  >
                </el-upload>
              </el-form-item>
              <el-form-item
                style="margin-bottom:0"
                v-if="tableShow"
                label="文件适配："
                prop=""
              >
                <div slot="label">
                  <i style="color:#F56C6C">*</i> 文件适配：
                </div>
                <div
                  class="grouping-divide table"
                  style="max-height:500px;overflow-y:auto"
                >
                  <table class="grouping_table" border="1">
                    <tr style="text-align:left">
                      <th>账户</th>
                      <th>合约</th>
                      <th>分组</th>
                      <th style="text-align:center">总持仓</th>
                      <th style="text-align:center">分配持仓</th>
                      <th style="text-align:center">买卖</th>
                      <th style="text-align:right">开仓均价</th>
                      <th style="text-align:right">开仓成本</th>
                    </tr>
                    <tbody v-for="(item, index) in tableData" :key="index">
                      <tr v-for="(e, i) in item.groupName" :key="i + 1000">
                        <!-- 账号 -->
                        <td v-if="i == 0" :rowspan="item.groupName.length">
                          {{ item.UserCode }}
                        </td>
                        <!-- 合约 -->
                        <td v-if="i == 0" :rowspan="item.groupName.length">
                          {{ item.InstrumentId }}
                        </td>
                        <!-- 分组 -->
                        <td>{{ e }}</td>
                        <!-- 总持仓 -->
                        <td
                          style="text-align:center"
                          v-if="i == 0"
                          :rowspan="item.groupName.length"
                        >
                          {{ item.Position }}
                        </td>
                        <!-- 分配持仓 -->
                        <td >
                          <!-- <el-input
                            v-model="item.positions[i]"
                            style="width:60px;margin-left:20px"
                            size="small"
                            placeholder=""
                          ></el-input> -->
                          <el-input-number 
                            v-model="item.positions[i]" 
                            style="width:100px;" 
                            controls-position="right" 
                            @change="handleChange($event,index,i)" 
                            :min="0" 
                            :max="parseInt(item.Position)"
                          ></el-input-number>
                        </td>
                        <!-- 买卖 -->
                        <td
                          v-if="i == 0"
                          :style="{
                            color:
                              item.PosiDirectionText == '买'
                                ? '#FF2A2A'
                                : '#08AE47',
                            textAlign: 'center'
                          }"
                          :rowspan="item.groupName.length"
                        >
                          {{ item.PosiDirectionText }}
                        </td>
                        <!-- 开仓均价 -->
                        <td
                          style="text-align:right;"
                          v-if="i == 0"
                          :rowspan="item.groupName.length"
                        >
                          {{ item.AveragePrice | rbstateFormat }}
                        </td>
                        <!-- 开仓成本 -->
                        <td
                          style="text-align:right;"
                          v-if="i == 0"
                          :rowspan="item.groupName.length"
                        >
                          {{ item.OpenCost | rbstateFormat }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </el-form-item>
            </el-form>
            <div v-if="tableShow" class="form_btn" style="margin-top: 20px;">
              <button @click="submit_c()">保存</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import nnav from "../../../components/nav/index";
import vuedraggable from "vuedraggable";
import Sortable from "sortablejs";

import "@/assets/icon1/iconfont.css";
import "./style.css";
export default {
  name: "eval_jees",
  components: { nnav, vuedraggable },

  data() {
    return {
      exportLoading: false,
      tableShow: false,
      exportShow: false,
      count: 0,
      loading: false,
      dialogWidth: "500px",
      MHeight: document.documentElement.clientHeight - 160 + "px",
      searchName: "", //搜索名称
      activeName: "",
      title: "添加", //
      isShow: false,
      editId: "", // 修改分组名称的id

      checkedAll: false,

      groupId: "",
      showType: {
        add: false,
        name: false,
        edit: false,
        export: false
      },
      ruleForm: {
        name: "" //分组名称
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      },
      name: "", //分组名称
      listRes: [], //分组列表数据
      teamList: [], //团队成员
      userList: [], //交易账户
      tabArray: [], //表格分页数据
      allData: [], //查看汇总数据
      excelData: [], //excel导出数据
      theadData: [], //上传的表头
      theadData_1: [], //上传的表头
      managerId: "", //分组ID
      path: "", //文件路径
      path_1: "", //文件路径
      tableData: [],
      downloadShow: false,
      arr1: [],
      arr2: [],
      userRightList: [],
      userLeftList: [],
      selectionLeft: [],
      selectionRight: []
    };
  },
  filters: {
    value: function(e) {
      if (e) {
        let num = 0;
        e.forEach(item => {
          num += item * 1;
        });
        return num;
      } else {
        return "0";
      }
    }
  },
  created() {
    this.exportAxios();
  },

  mounted() {
    this.listOrSeeBtn();
  },

  methods: {
    drop() {
      // 业务场景描述行拖拽
      const tbody = document.querySelector(".table_t tbody");
      const that = this;
      Sortable.create(tbody, {
        animation: 500, // 拖拽动画
        onEnd: function(evt) {
          console.log(that.userRightList);
          that.userRightList.splice(
            evt.newIndex,
            0,
            that.userRightList.splice(evt.oldIndex, 1)[0]
          );
        }
      });
    },
    exportAxios() {
      this.$axios
        .post("/cloud/eval_jees/initializationData", {
          apiToken: this.$store.state.usermsg.apiToken
        })
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.exportShow = true;
          } else {
            this.exportShow = false;
          }
        });
    },
    listOrSeeBtn() {
      this.$axios
        .post("/api_eval/group_list", {
          token: this.$store.state.usermsg.apiToken,
          name: this.searchName
        })
        .then(res => {
          console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            let arr = [];
            this.listRes = res.data.datas;
            this.activeName = res.data.datas[0].name;
            this.listRes.forEach(item => {
              arr.push(item.evalJees.slice(0, 5));
            });
            this.tabArray = arr;
          }

          this.$axios
            .post("/cloud/eval_jees/groupSummaryData", {
              apiToken: this.$store.state.usermsg.apiToken,
              groupingId: res.data.datas[0].id
            })
            .then(res => {
              console.log(res);

              if (res.data.code == 200) {
                this.allData = res.data.data;
              } else {
                this.$alert(res.data.message, {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true
                })
                  .then(() => {})
                  .catch(() => {});
              }
            });
        });
    },
    body(type) {
      //锁定滚动条
      var m = document.getElementsByTagName("body")[0];
      m.style.overflowY = type;
    },
    addBtn(e, type) {
      //添加
      if (!type) {
        this.isShow = true;
        this.showType.add = true;
        this.title = "添加";
        this.dialogWidth = "500px";
        this.body("hidden");
      } else {
        this.ruleForm.name = e.name;
        this.editId = e.id;
        this.isShow = true;
        this.showType.name = true;
        this.title = "编辑";
        this.dialogWidth = "500px";
        this.body("hidden");
      }
    },
    addExport() {
      if (this.exportShow) {
        //导入初始化数据
        this.title = "导入初始化数据";
        this.isShow = true;
        this.dialogWidth = "1180px";
        this.showType.export = true;
      } else {
        this.$alert("分组已有数据，无法初始化数据", {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    search() {
      //搜索
      this.list();
    },
    reset() {
      //重置
      this.searchName = "";
      this.list();
    },
    nameEdit() {
      //编辑分组名称
    },
    editBtn(e) {
      //编辑
      this.groupId = e.id;
      this.$axios
        .post("/api_eval/returnData", {
          token: this.$store.state.usermsg.apiToken,
          groupId: e.id
        })
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.isShow = true;

            this.body("hidden");
            this.dialogWidth = "1300px";
            this.showType.edit = true;
            this.title = "编辑";
            // this.userList = res.data.datas;
            this.userLeftList = [];
            this.userRightList = [];
            res.data.datas.forEach(el => {
              if (el.checked) {
                this.userRightList.push(el);
                // this.$nextTick(r => {
                //   this.$refs.rightDataList.toggleRowSelection(el, true);
                // });
              } else {
                this.userLeftList.push(el);
              }
            });

            let num = 0;
            res.data.datas.forEach(item => {
              if (item.checked) {
                num++;
              }
            });
            this.count = num;

            if (this.isShow && this.showType.edit) {
              setTimeout(() => {
                this.drop();
              }, 1000);
            }
          } else {
            this.$alert(res.data.message, {
              confirmButtonText: "确定",
              type: "error",
              center: true
            })
              .then(() => {})
              .catch(() => {});
          }
        });
    },
    style_none(row) {
      console.log(row.row.checked);
      // if (row.row.checked) {
      //   return "styleNone";
      // }
    },
    style_block(row) {
      // if (!row.row.checked) {
      //   return "styleNone";
      // }
      return "tabHover";
    },

    rightShiftFun() {
      for (let ii = 0; ii < this.selectionLeft.length; ii++) {
        for (let i = 0; i < this.userLeftList.length; i++) {
          if (this.userLeftList[i].id == this.selectionLeft[ii].id) {
            this.userLeftList.splice(i, 1);
          }
        }
      }
      this.userRightList = this.userRightList.concat(this.selectionLeft);
      this.selectionLeft = [];
    },
    leftShiftFun() {
      for (let ii = 0; ii < this.selectionRight.length; ii++) {
        for (let i = 0; i < this.userRightList.length; i++) {
          if (this.userRightList[i].id == this.selectionRight[ii].id) {
            this.userRightList.splice(i, 1);
          }
        }
      }
      this.userLeftList = this.userLeftList.concat(this.selectionRight);
      this.userLeftList.forEach(el => {
        el.multiple = "1";
      });
      this.selectionRight = [];
    },
    selectRowleft(selection, row) {
      this.selectionLeft = selection;
    },
    selectAllRowleft(row) {
      this.selectionLeft = row;
    },
    selectRowright(selection, row) {
      this.selectionRight = selection;
    },
    selectAllRowright(row) {
      this.selectionRight = row;
    },
    checkChange(e, i) {
      console.log(e);
      // e.row.checked = !e.row.checked;
      // this.arr1 = [];
      // this.arr2 = [];
      // let num = 0;
      // this.userList.forEach(item => {
      //   if (item.checked) {
      //     this.arr1.push(item);
      //     num++;
      //   } else {
      //     this.arr2.push(item);
      //   }
      // });
      // this.count = num;
      // this.userList = arr1.concat(arr2);
    },
    upBtn(e, index) {
      //向上
      var arr = this.userList;
      var num = 0;
      arr.forEach(item => {
        if (item.checked) {
          num++;
        }
      });
      if (index > 0 && index < num) {
        var arr = this.userList;
        arr.splice(index - 1, 1, ...arr.splice(index, 1, arr[index - 1]));
      }
    },
    downBtn(e, index) {
      //向下

      var arr = this.userList;
      var num = 0;
      arr.forEach(item => {
        if (item.checked) {
          num++;
        }
      });

      if (index < num - 1) {
        arr.splice(index + 1, 1, ...arr.splice(index, 1, arr[index + 1]));
      }
    },
    uploadBtn(e) {
      //输入数据
      this.title = "导入汇总数据";
      this.dialogWidth = "600px";
      this.isShow = true;

      this.showType.upload = true;
      this.managerId = e.id;
      this.body("hidden");
    },
    downloadBtn(e) {
      //输入数据
      // this.title = "提示";
      // this.dialogWidth = "600px";
      // this.isShow = true;

      // this.downloadShow = true;
      // this.body("hidden");
      this.$confirm(`是否确认下载持仓汇总数据？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.exportData();
        })
        .catch(() => {});
    },

    delBtn(e) {
      //刪除
      this.$confirm(`您确定要删除分组“${e.name}”吗？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.$axios
            .post("/api_eval/group_del", {
              token: this.$store.state.usermsg.apiToken,
              id: e.id
            })
            .then(res => {
              if (res.data.code == 200) {
                this.listOrSeeBtn();
              } else {
                this.$alert(res.data.message, {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true
                })
                  .then(() => {})
                  .catch(() => {});
              }
            });
        })
        .catch(() => {});
    },
    exportData() {
      //导出按钮
      this.excelData = this.allData; //将你要导出的数组数据（historyList）赋值给excelDate
      this.export2Excel(); //调用export2Excel函数，填写表头（clomns里的type）和对应字段(historyList里的属性名)
      this.clearBtn();
    },
    export2Excel() {
      var that = this;
      require.ensure([], () => {
        const {
          export_json_to_excel
        } = require("@/components/excel/Export2Excel");
        //这里使用绝对路径( @表示src文件夹 )，使用@/+存放export2Excel的路径【也可以写成相对于你当前"xxx.vue"文件的相对路径，例如我的页面放在assets文件夹同级下的views文件夹下的“home.vue”里，那这里路径也可以写成"../assets/excel/Export2Excel"】
        const tHeader = [
          "账号",
          "合约",
          "买卖",
          "手数",
          "开仓均价",
          "开仓成本"
        ]; // 导出的excel表头名信息
        const filterVal = [
          "userCode",

          "instrumentID",
          "posiDirectionText",
          "position",
          "averagePrice",
          "openCost"
        ]; // 导出的excel表头字段名，需要导出表格字段名
        const list = that.excelData;
        const data = that.formatJson(filterVal, list);

        export_json_to_excel(tHeader, data, "汇总数据"); // 导出的表格名称，根据需要自己命名
      });
    },
    //格式转换，直接复制即可,不需要修改什么
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    dataDelBtn(e) {
      console.log(e);
      var color = e.posiDirection == 50 ? "#f00" : "#10c866";
      this.$confirm(
        `您确定要删除该数据吗？<br/><div style="text-align:left !important;margin-left:130px;">账号：${
          e.userCode
        }<br/>合约：${e.instrumentID}<br/>买卖：<span style="color:${color}">${
          e.posiDirection == 50 ? "买" : "卖"
        }</span><br/>持仓：${e.position}</div>`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$axios
            .post("/cloud/eval_jees/delPersonageGroupingData", {
              apiToken: this.$store.state.usermsg.apiToken,
              groupingId: e.busiUnit,
              userCode: e.userCode,
              instrumentId: e.instrumentID,
              posiDirection: e.posiDirection,
              userID: e.userID,
              userType: e.userType,
              serverFlag: e.serverFlag
            })
            .then(res => {
              console.log(res);
              this.exportAxios();
              this.$axios
                .post("/cloud/eval_jees/groupSummaryData", {
                  apiToken: this.$store.state.usermsg.apiToken,
                  groupingId: e.busiUnit
                })
                .then(res => {
                  console.log(res);
                  this.tokenInvalid(res);
                  if (res.data.code == 200) {
                    // this.title = "查看汇总数据"
                    // this.isShow = true
                    // this.showType.see = true
                    this.allData = res.data.data;
                    // this.body('hidden')
                  } else {
                    this.$alert(res.data.message, {
                      confirmButtonText: "确定",
                      type: "error",
                      center: true
                    })
                      .then(() => {})
                      .catch(() => {});
                  }
                });
            })
            .catch(err => {});
        })
        .catch(() => {});
    },
    uploadSubmit() {
      //导入excel提交
      if (this.path) {
        //文件路径是否存在
        this.loading = true;
        let userCodeSubScript = "";
        let TradingDaySubScript = "";
        let DirectionSubScript = "";
        let averagePriceSubScript = "";
        let InstrumentIDSubScript = "";
        let PositionSubScript = "";
        let PositionDaySubScript = "";
        let OpenCostSubScript = "";
        let PositionCostSubScript = "";

        if (this.theadData) {
          this.theadData.forEach((item, index) => {
            console.log(item, index);
            if (item == "账户" || item == "账号") {
              userCodeSubScript = index;
            } else if (item == "交易日") {
              TradingDaySubScript = index;
            } else if (item == "买卖") {
              DirectionSubScript = index;
            } else if (item == "开仓均价") {
              averagePriceSubScript = index;
            } else if (item == "合约") {
              InstrumentIDSubScript = index;
            } else if (item == "手数") {
              PositionSubScript = index;
            }
            // else if(item == "当日手数"){
            //     PositionDaySubScript = index
            // }
            else if (item == "开仓成本") {
              OpenCostSubScript = index;
            }
            // else if(item == "持仓成本"){
            //     PositionCostSubScript = index
            // }
          });
        }
        console.log(
          userCodeSubScript,
          TradingDaySubScript,
          DirectionSubScript,
          averagePriceSubScript,
          InstrumentIDSubScript,
          PositionSubScript,
          OpenCostSubScript
        );
        this.$axios
          .post("/cloud/eval_jees/addPersonageSubmitData", {
            apiToken: this.$store.state.usermsg.apiToken,
            path: this.path,
            groupingId: this.managerId, //分组id
            userCodeSubScript:
              userCodeSubScript || userCodeSubScript === 0
                ? userCodeSubScript
                : -1, //交易账户id
            TradingDaySubScript:
              TradingDaySubScript || TradingDaySubScript === 0
                ? TradingDaySubScript
                : -1, //交易日
            DirectionSubScript:
              DirectionSubScript || DirectionSubScript === 0
                ? DirectionSubScript
                : -1, //买卖
            averagePriceSubScript:
              averagePriceSubScript || averagePriceSubScript === 0
                ? averagePriceSubScript
                : -1, //均价
            InstrumentIDSubScript:
              InstrumentIDSubScript || InstrumentIDSubScript === 0
                ? InstrumentIDSubScript
                : -1, //合约
            PositionSubScript:
              PositionSubScript || PositionSubScript === 0
                ? PositionSubScript
                : -1, //总持仓
            // PositionDaySubScript:  PositionDaySubScript,//当日持仓
            OpenCostSubScript:
              OpenCostSubScript || OpenCostSubScript === 0
                ? OpenCostSubScript
                : -1 //开仓成本
            // PositionCostSubScript:PositionCostSubScript//持仓成本
          })
          .then(res => {
            console.log(res);
            this.loading = false;
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.$alert(res.data.message, {
                confirmButtonText: "确定",
                dangerouslyUseHTMLString: true,
                type: "success",
                center: true
              })
                .then(() => {
                  this.listRes.forEach((e, i) => {
                    console.log(e.name, this.activeName);
                    if (e.name == this.activeName) {
                      this.seeBtn({ index: i });
                    }
                  });
                  this.clearBtn();
                })
                .catch(() => {});
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: "确定",
                dangerouslyUseHTMLString: true,
                type: "error",
                center: true
              })
                .then(() => {})
                .catch(() => {});
            }
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
        this.$alert("请选择导入文件", {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    removeBtn() {
      //数据删除
      this.path = ""; //删除文件路径
    },
    removeBtn_1() {
      this.path_1 = ""; //删除文件路径
      this.tableData = [];
      this.tableShow = false;
    },
    handleAvatarSuccess(res, file) {
      //导入excel

      console.log(res);
      this.tokenInvalid(res);
      if (res.code == 200) {
        this.path = res.data.filePath;
        this.$axios
          .post(
            //获取表头
            "/crm/acc/to_lead",
            {
              apiToken: this.$store.state.usermsg.apiToken,
              path: res.data.filePath
            }
          )
          .then(r => {
            console.log(r);
            if (r.data.code == 200) {
              this.theadData = r.data.data;
            } else {
              this.$alert(r.data.message, {
                confirmButtonText: "确定",
                type: "error",
                center: true
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      } else {
        this.$alert(res.data.message, {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    handleAvatarSuccess_1(res, file) {
      console.log(res);
      if (res.code == 200) {
        this.path_1 = res.data.filePath;

        this.$axios
          .post(
            //获取表头
            "/crm/acc/to_lead",
            {
              apiToken: this.$store.state.usermsg.apiToken,
              path: res.data.filePath
            }
          )
          .then(r => {
            console.log(r);
            if (r.data.code == 200) {
              this.theadData_1 = r.data.data;
              let userCodeSubScript = ""; //账号
              let DirectionSubScript = ""; //买卖
              let averagePriceSubScript = ""; //均价
              let InstrumentIDSubScript = ""; //合约
              let PositionSubScript = ""; //总持仓
              let OpenCostSubScript = ""; //开仓成本

              if (r.data.data) {
                r.data.data.forEach((item, index) => {
                  if (item == "账号" || item == "账户") {
                    userCodeSubScript = index;
                  } else if (item == "多仓") {
                    DirectionSubScript = index;
                  } else if (item == "开仓均价") {
                    averagePriceSubScript = index;
                  } else if (item == "合约") {
                    InstrumentIDSubScript = index;
                  } else if (item == "总持仓") {
                    PositionSubScript = index;
                  } else if (item == "开仓成本") {
                    OpenCostSubScript = index;
                  }
                });
              }

              this.$axios
                .post("/cloud/eval_jees/addInitializeData", {
                  apiToken: this.$store.state.usermsg.apiToken,
                  path: this.path_1,
                  userCodeSubScript:
                    userCodeSubScript || userCodeSubScript === 0
                      ? userCodeSubScript
                      : -1,
                  DirectionSubScript:
                    DirectionSubScript || DirectionSubScript === 0
                      ? DirectionSubScript
                      : -1,
                  averagePriceSubScript:
                    averagePriceSubScript || averagePriceSubScript === 0
                      ? averagePriceSubScript
                      : -1,
                  InstrumentIDSubScript:
                    InstrumentIDSubScript || InstrumentIDSubScript === 0
                      ? InstrumentIDSubScript
                      : -1,
                  PositionSubScript:
                    PositionSubScript || PositionSubScript === 0
                      ? PositionSubScript
                      : -1,
                  OpenCostSubScript:
                    OpenCostSubScript || OpenCostSubScript === 0
                      ? OpenCostSubScript
                      : -1
                })
                .then(rep => {
                  console.log(rep);
                  if (rep.data.code == 200) {
                    this.tableShow = true;
                    rep.data.data.forEach(el=>{
                      if(el.positions.length > 0){
                        el.positions[0] = parseInt(el.Position)
                      }
                    })
                    this.tableData = rep.data.data;
                  } else {
                    this.$alert(rep.data.message, {
                      confirmButtonText: "确定",
                      type: "error",
                      center: true
                    })
                      .then(() => {})
                      .catch(() => {});
                  }
                });
            } else {
              this.$alert(r.data.message, {
                confirmButtonText: "确定",
                type: "error",
                center: true
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      } else {
        this.$alert(res.data.message, {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    clearBtn() {
      //清除
      this.isShow = false;
      this.downloadShow = false;
      this.body("auto");
      this.groupId = "";
      this.showType = {
        add: false,
        name: false,
        edit: false,
        export: false
      };
      this.tableData = [];
      this.path_1 = "";
      this.tableShow = false;
      if (this.showType.add) {
        this.$refs["ruleForm"].resetFields();
      }
      this.ruleForm.name = "";
    },
    submit() {
      //提交

      console.log(this.activeName, "this.activeName");
      if (this.showType.add) {
        this.$axios
          .post("/api_eval/group_add", {
            token: this.$store.state.usermsg.apiToken,
            name: this.ruleForm.name
          })
          .then(res => {
            console.log(res);
            if (res.data.code == 200) {
              this.listOrSeeBtn();
              this.clearBtn();
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: "确定",
                type: "error",
                center: true
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      } else if (this.showType.name) {
        this.$axios
          .post("/api_eval/group_updateTwo", {
            token: this.$store.state.usermsg.apiToken,
            name: this.ruleForm.name,
            id: this.editId
          })
          .then(res => {
            console.log(res, 666666);
            if (res.data.code == 200) {
              this.clearBtn();
              this.list();
              this.activeName = res.data.data.name;
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: "确定",
                type: "error",
                center: true
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      }
    },
    submit_c() {
      if (this.path_1) {
        //导入初始化数据提交.
        let groupIds = [];
        let userCodes = [];
        let direction = [];
        let averagePrice = [];
        let instrumentIDs = [];
        let positions = [];
        let positionsNum = 0;
        let positionsAll = 0;
        let openCost = [];
        let ProductId = [];
        let ExchangeId = [];
        let VolumeMultiple = [];

        this.tableData.forEach((item, index) => {
          item.positions.forEach((e, i) => {
            groupIds.push(item.groupId[i]);
            userCodes.push(item.UserCode);
            direction.push(item.PosiDirection);
            averagePrice.push(item.AveragePrice);
            instrumentIDs.push(item.InstrumentId);
            ProductId.push(item.ProductId);
            ExchangeId.push(item.ExchangeId);
            VolumeMultiple.push(item.VolumeMultiple);
            positions.push(e);
            positionsAll += e * 1;
            openCost.push(item.OpenCost);
          });
          positionsNum += item.Position * 1;

          console.log(
            groupIds,
            userCodes,
            direction,
            averagePrice,
            instrumentIDs,
            positions,
            positionsAll,
            "----",
            positionsNum
          );
        });

        if (positionsNum == positionsAll) {
          this.loading = true;

          this.$axios
            .post("/cloud/eval_jees/saveGroupedPositionData", {
              apiToken: this.$store.state.usermsg.apiToken,
              groupIds: groupIds,
              userCodes: userCodes,
              direction: direction,
              averagePrice: averagePrice,
              instrumentIDs: instrumentIDs,
              positions: positions,
              openCost: openCost,
              ProductId: ProductId,
              ExchangeId: ExchangeId,
              VolumeMultiple: VolumeMultiple
            })
            .then(res => {
              console.log(res);
              this.loading = false;
              if (res.data.code == 200) {
                this.clearBtn();
                this.listOrSeeBtn();
                this.exportAxios();
              } else {
                this.$alert(res.data.message, {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true
                })
                  .then(() => {})
                  .catch(() => {});
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          this.$alert("请合理分配持仓", {
            confirmButtonText: "确定",
            type: "error",
            center: true
          })
            .then(() => {})
            .catch(() => {});
        }
      } else {
        this.$alert("请上传文件", {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    editSubmit() {
      // 编辑提交
      let str = "";
      let flag = true;
      let arr = [];
      // this.userList.forEach(item => {
      //   if (item.checked) {
      //     arr.push(item.id);
      //     if (item.multiple) {
      //       str += "|" + item.id + "_" + item.multiple;
      //     } else {
      //       flag = false;
      //     }
      //   }
      // });
      this.userRightList.forEach(item => {
        arr.push(item.id);
        if (item.multiple) {
          str += "|" + item.id + "_" + item.multiple;
        } else {
          flag = false;
        }
      });
      console.log(flag);
      if (flag) {
        this.$axios
          .post("/api_eval/group_bind", {
            token: this.$store.state.usermsg.apiToken,
            groupId: this.groupId,
            accList: str.replace("|", ""),
            groupSort: arr
          })
          .then(res => {
            console.log(res);
            if (res.data.code == 200) {
              this.list();
              this.clearBtn();
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: "确定",
                type: "error",
                center: true
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      } else {
        this.$alert("交易倍率至少为1倍", {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    list() {
      // 分组列表
      this.$axios
        .post("/api_eval/group_list", {
          token: this.$store.state.usermsg.apiToken,
          name: this.searchName
        })
        .then(res => {
          console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            let arr = [];
            this.listRes = res.data.datas;

            this.listRes.forEach(item => {
              arr.push(item.evalJees.slice(0, 5));
            });
            this.tabArray = arr;
          }
        });
    },
    currentPage(page, i) {
      //分页
      this.tabArray.splice(
        i,
        1,
        this.listRes[i].evalJees.slice(page * 5 - 5, page * 5)
      );
    },
    handleChange(currentValue,index,i){
      if(this.tableData[index].groupName.length == 2){
        if(i==0){
          this.tableData[index].positions[1] = this.tableData[index].Position - currentValue
        }else{
          this.tableData[index].positions[0] = this.tableData[index].Position - currentValue
        }
      }
    },
    renderHeader(h, { column }) {
      //表头全选
      return h("span", [
        h("el-checkbox", {
          style: "display:inline-flex;",
          on: {
            change: this.select
          },
          props: {
            value: this.checkedAll
          }
        }),
        h("span", column.label)
      ]);
    },
    select(checked) {
      // 如果checked为true则是勾选了对应的表头
      this.checkedAll = !this.checkedAll;

      if (checked) {
        this.userList.map(item => {
          item.checked = true;
        });
      } else {
        this.userList.map(item => {
          item.checked = false;
        });
      }
      let num = 0;
      this.userList.forEach(item => {
        if (item.checked) {
          num++;
        }
      });
      this.count = num;
    },

    seeBtn(e) {
      this.$axios
        .post("/cloud/eval_jees/groupSummaryData", {
          apiToken: this.$store.state.usermsg.apiToken,
          groupingId: this.listRes[e.index].id
        })
        .then(res => {
          console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            // this.title = "查看汇总数据"
            // this.isShow = true
            // this.showType.see = true
            this.allData = res.data.data;
            // this.body('hidden')
          } else {
            this.$alert(res.data.message, {
              confirmButtonText: "确定",
              type: "error",
              center: true
            })
              .then(() => {})
              .catch(() => {});
          }
        });
    }
  },

  watch: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/view/user/grouping/index.vue